import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const HeaderLabel = styled.div<{ $isRightAlignment?: boolean }>`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
  user-select: none;
  text-align: ${({ $isRightAlignment }) => $isRightAlignment && 'right'};
`;
